export default "__VITE_ASSET__BjyoTqn6__"